import { connect } from 'react-redux'
//import { state_update } from '../actions'
import AiReview from './AiReview'
import {DEFAULT_STATE_VALUE,ALL_STONES} from '../constants';
import {diamond_minmax,getValueFromDictArray,decodeHtml} from '../reducers/utils'
import ReactGA from 'react-ga';
const mapStateToProps = (state, ownProps) => ({
  gems: isGemExist(state),
  properties: getDescription(state),
 // options_all:state['options_all'],
  description:decodeHtml(state['description']),
  site:state['site'],
  version:state.version,
  showReview:state.showReview ? 'ai-show' : 'ai-hide',
  bolo:state['description']==null?'':(state['description'].toLowerCase().indexOf('bracelet') !==-1 &&(state['description'].toLowerCase().indexOf('bolo') ===-1 &&state['description'].toLowerCase().indexOf('adjust') ===-1 )),
  lgd: isLGD(state)
  
})
const isGemExist = (state)=>{
  for (let key in state['options_all'])
  {
   var keyValue=state['options_all'][key]
  if (ALL_STONES.indexOf(keyValue)  !== -1) {
    if (state[keyValue] !== DEFAULT_STATE_VALUE) {
     return true 
    }  
  }
 }
 return false
}

const isLGD = (state)=>{
  var lgd_sel = false
  for (let gem of ALL_STONES)
  {
      if (state[gem] == 'd')
          lgd_sel = true
  }
  return state.lgd !== undefined && lgd_sel
}

const getDescription = (state)=>{
  var res=[];
  const flowerName = {
    "6370":["garnet","Carnation","January"],
"7773":["amethyst","Violet","February"],
"6372":["aquamarine","Daffodil","March"],
"6373":["white topaz","Daisy","April"],
"6375":["emerald","Hawthorn","May"],
"6377":["alexandrite","Rose","June"],
"6376":["ruby","Waterlily","July"],
"6374":["peridot","Poppy","August"],
"7774":["sapphire","Morning Glory","September"],
"6379":["opal","Cosmos","October"],
"6380":["citrine","Chrysanthemum","November"],
"7909":["blue topaz","Poinsettia","December"]

  }
  const propertyName = {
    d:'Design',
    i:'Letter',
    c:'Center Stone',
    s1:'Stone 1',
    s2:'Stone 2',
    s3:'Stone 3',
    s4:'Stone 4',
    s5:'Stone 5',
    s6:'Stone 6',
    s7:'Stone 7',
    s8:'Stone 8',
    s9:'Stone 9',
    s10:'Stone 10',
    a1:'Accent Stone 1',
    a2:'Accent Stone 2',
    a3:'Accent Stone 3',
    a4:'Accent Stone 4',
    a5:'Accent Stone 5',
    a6:'Accent Stone 6',
    a7:'Accent Stone 7',
    a8:'Accent Stone 8',
    a9:'Accent Stone 9',
    a10:'Accent Stone 10',
    m: 'Metal',
    e: 'Engraving Text Line ',
    rs: 'Ring Size',
    cl:'Chain Length',
    cl2:'Extender Length',
    bl:'Bracelet Length',
    bl2:'Extender Length',
    Height: 'Height',
    Width: 'Width',
    'Earring Type': 'Earring Type',
    Diamond: 'Diamond',
  }
  const valueName = {
    s:'Sterling Silver',
    spy:'10K Yellow Gold Plated Over Sterling Silver',
    spr:'10K Gold Rose Plated Over Sterling Silver',
    t:'Titanium',
    ss:'Stainless Steel',
    g10y:'10K Yellow Gold',
    g14y:'14K Yellow Gold',
    g10w:'10K White Gold',
    g14w:'14K White Gold',
    g10r:'10K Rose Gold',
    g14r:'14K Rose Gold',
    am:"Amethyst",
    al:"Alexandrite",
    aq:"Aquamarine",
    bt:"Blue Topaz",
    bo:"Black Onyx",
    bs:"Black Spinel",
    ci:"Citrine",
    em:"Emerald",
    gr:"Garnet",
    ga:"Green Quartz",
    gs:"Green Sapphire",
    op:"Opal",
    pe:"Peridot",
    ps:"Pink Sapphire",
    ru:"Ruby",
    sa:"Sapphire",
    sq:"Smoky Quartz",
    ws:"White Sapphire",
    wt:"White Topaz",
    d: 'Diamond',
    I1: 'I1 - I2',
    I2: 'I2 - I3',
    I3: 'I3',
    black: 'Black Diamond'
  }
  let addFont = false
  let curProp;
  let curValue;
  let finalValue;
  let all_options_plus_default = state['options_all'].slice()
  let default_options =['m','bl','cl']  
  let diamondrdy = true
   for (let new_opt in default_options) {
     if (state[default_options[new_opt]] !== DEFAULT_STATE_VALUE && state['options_all'].indexOf(default_options[new_opt])  === -1) {
       all_options_plus_default.push(default_options[new_opt])
     }

  }
 //console.log('all',all_options_plus_default)
 //console.log('REVIEW STATE',state)
  
  for (let key in all_options_plus_default)
  {
    // if (key.indexOf('options_') === -1)
   // res =res+key+':'+ state[key]+ ' '
   var keyValue=all_options_plus_default[key]
   if (( state.hasOwnProperty('options_' + keyValue) === true && state['options_' + keyValue].show === false) ||
        state[keyValue] === DEFAULT_STATE_VALUE) 
      continue
   if (ALL_STONES.indexOf(keyValue)  !== -1) {
     // process all stones
    if (propertyName.hasOwnProperty(keyValue))
      curProp = propertyName[keyValue]
    else
      curProp = state['options_'+keyValue].name  
    curValue =state[keyValue]
    var stoneQuality =getValueFromDictArray(state['options_' + keyValue].options,'value',curValue,'quality')
    if (stoneQuality !== "L") {
        stoneQuality = ' '
    }
    else {
        if (curValue === 'd') {
            stoneQuality=' Lab-Grown '
        }
        else {
            stoneQuality=' Lab-Created '
        }
    }
    
    //console.log('arelem',keyValue)

    if (valueName.hasOwnProperty(curValue))
        curValue = valueName[curValue]
    if  (state['options_' + keyValue].hasOwnProperty('description')){    
    let val =state['options_' + keyValue].description.split('|') 
    if (state['cs_details'].hasOwnProperty(state['sku'])){
      if (state['cs_details'][state['sku']].hasOwnProperty(keyValue)){
       let dyn_desc_arr= state['cs_details'][state['sku']][keyValue]
       for (var arrelem in dyn_desc_arr){
        let dyn_desc =dyn_desc_arr[arrelem] 
       // console.log('arelem',arrelem,dyn_desc_arr)
        //let dyn_desc =arrelem
        val[1]=dyn_desc['qty']
        val[2]= dyn_desc['size']
        val[3]= dyn_desc['shape']
        finalValue = '('+val[1] +') '+ val[2]+'mm '+ val[3] + stoneQuality +curValue 
        if (state.lgd !== undefined && curValue == 'Diamond') {
          //finalValue+= ' (Color G, Clarity VS2)'
          if (state.lgd !== "")
            finalValue = val[3][0].toUpperCase() + val[3].slice(1) + stoneQuality + curValue + ' (Total Weight ' +  state.lgd + ' CT., Clarity VS2, Color G)'
          else
            finalValue = val[3][0].toUpperCase() + val[3].slice(1) + stoneQuality + curValue + ' (Clarity VS2, Color G)'
          if (val[4] !== '') 
            finalValue+= ' in a '+ val[4] + ' setting'
        } else if (val[4] !== '') 
          finalValue+= ' stone in a '+ val[4] + ' setting'
        else if (curValue !== 'Diamond')
          finalValue+= ' stone'
        else if (curValue == 'Diamond') {
          //finalValue+= ' (Color G, Clarity VS2)'
          finalValue = val[3][0].toUpperCase() + val[3].slice(1) + stoneQuality + curValue + ' (Total Weight ' +  state.lgd + ' CT., Clarity VS2, Color G)'
        }
          
        if (diamondrdy) {
          if (curValue == 'Diamond' && state.lgd == undefined) {
            diamondrdy = false
          }
        if (keyValue === 'a1' && !state['options_all'].includes('a2')){
          res.push({property:'Accent Stone',value:finalValue})
        }
        else if (dyn_desc_arr.length >1){
          res.push({property:'Stone',value:finalValue})
        }
        else  
          res.push({property:curProp,value:finalValue})
        }
        }
      }
    }  
    }
   }
   else if (keyValue === 'cl' ||keyValue === 'bl' ) {
    curProp = propertyName[keyValue]
    curValue =state[keyValue]
    finalValue = curValue + ' inch'
    if (state.hasOwnProperty('options_' + keyValue)){
      let val =state['options_' + keyValue].description.split('|') 
      
      finalValue +=' '+val[0]
      if (val.length > 1) 
        finalValue+=' with secure '+ val[1]
    }
    else if (state['desc_clasp'] !== '') {
      finalValue+=' with secure '+ state['desc_clasp']
/*       if (keyValue ==='bl')
      if (state['desc_clasp']==='bolo'){
        if (curValue ==='8.5')
         finalValue = '9 1/2 inch with secure '+ state['desc_clasp']
         if (curValue ==='7')
         finalValue = '8 inch with secure '+ state['desc_clasp']
      } */
    } 
    res.push({property:curProp,value:finalValue})
    if (state[keyValue+'2'] !== undefined && state[keyValue+'2'] !== "")
      res.push({property:propertyName[keyValue+'2'],value:state[keyValue+'2'] + ' inch'})
  }
   else if (keyValue === 'sc') {
    curProp = state['options_sc'].name
    if(curProp.toLowerCase().includes('name'))
    curValue =state[keyValue]-1
    else
    curValue =state[keyValue]
    res.push({property:curProp,value:curValue})
     
   }
   else if (keyValue === 'i') {
    curProp = propertyName[keyValue]
    curValue =state[keyValue]
    if (!['1282','9303'].includes(state.style))
      curValue = curValue.toUpperCase()
    res.push({property:curProp,value:curValue})
     
   }
   else if (keyValue === 'd' && state.style==="6370") {
    curProp = propertyName[keyValue]
    curValue =flowerName[state["sku"]][1].toUpperCase()
    res.push({property:curProp,value:curValue})
    
    curProp = "Stone"
    curValue =flowerName[state["sku"]][0].toUpperCase()
    res.push({property:curProp,value:curValue})
     
   }

   else if (keyValue === 'd') {
    curProp = propertyName[keyValue]
    curValue =state[keyValue].toUpperCase()
    res.push({property:curProp,value:curValue})
     
   }
   
   else if (['e','f'].indexOf(keyValue)  === -1) {
    if (state[keyValue] !== DEFAULT_STATE_VALUE) {
      //console.log('not e-f',keyValue,state[keyValue],propertyName)
      if (propertyName.hasOwnProperty(keyValue))
        curProp = propertyName[keyValue]
      else
        curProp = state['options_'+keyValue].name  
      curValue =state[keyValue]
      if (curProp.indexOf('Letter') !== -1)
        curValue =state[keyValue].toUpperCase()
      else if (curProp.indexOf('Letter')  === -1 && valueName.hasOwnProperty(curValue))
        curValue = valueName[curValue]
        
      // console.log('stae now',curProp,curValue); 
      res.push({property:curProp,value:curValue})
    }  
   }

  //console.log('state now',key); 
  }
  if (state.hasOwnProperty('options_e')) {
   for (let i in state['options_e'].options) {
    // console.log('e option',i,state['e'+(parseInt(i)+1).toString()],propertyName['e'] +' '+ (parseInt(i)+1).toString())
      if (state['e'+(parseInt(i,10)+1).toString()] !== undefined && state['e'+(parseInt(i,10)+1).toString()] !== ''){
       res.push({property:propertyName['e'] +' '+ (parseInt(i,10)+1).toString(),value:state['e'+(parseInt(i,10)+1).toString()]})
       addFont = true
      }

    }

    if (addFont) {
      let fontName=''
      switch (state['f']) {
        case "0":
          fontName='Regular'
          break;
          case "1":
          fontName='Script'
          break;
          case "2":
          fontName='Monogram Circle'
          break;
          case "3":
          fontName='Monogram Vine'
          break;
          case "11":
          fontName='Script'
          break;
          case "12":
          fontName='Regular'
          break;
        default:
        fontName=''
        break;
      }
    res.push({property:'Font',value:fontName})
    }
  }
  if (state.hasOwnProperty('desc_static_stones')){
     var static_st=state['desc_static_stones'][state.sku]
     for (let i1 in static_st) {
   //   console.log('i1',i1)
      res.push({property:i1, value:static_st[i1]+ ' MM' })
     }
  }

  //  console.log('state',state)
  if (state.hasOwnProperty('options_description')) {
    for (let i in state['options_description'].options) {
       //console.log('review',state['options_description'].options[i])
       switch (state['options_description'].options[i].name) {
         case 'Diamond':
          let val =state['options_description'].options[i].value.split('|')
          if (state['cs_details'].hasOwnProperty(state['sku']+'-ctw')){
             let dyn_desc= state['cs_details'][state['sku']+'-ctw']
              val[1]=dyn_desc
          }  
          if (state['cs_details'].hasOwnProperty(state['sku']+'-ctwqty')){
            let dyn_desc= state['cs_details'][state['sku']+'-ctwqty']
             val[0]=dyn_desc
          }  
         let finalVal ='('+val[0]+') '+val[1]+' ct tw. round diamonds in a ' + val[3] + ' setting. Quality - '
          + valueName[val[2]] +'. Color - H-I. Diamond Total Carat Weight may range from ' 
          +  diamond_minmax(val[1]) +' carats.'
          res.push({property:'Diamond',value:finalVal})
          break;
         case 'Height':
          if (state.hasOwnProperty('sku_heights'))
           res.push({property:propertyName[state['options_description'].options[i].name], value:state['sku_heights'][state.sku] + ' MM' })
          else 
           res.push({property:propertyName[state['options_description'].options[i].name], value:state['options_description'].options[i].value + ' MM' })
          break;
         case 'Width':
          res.push({property:propertyName[state['options_description'].options[i].name], value:state['options_description'].options[i].value + ' MM' })
          break;
         case 'Earring Type':
          res.push({property:propertyName[state['options_description'].options[i].name], value:'Secured with ' + state['options_description'].options[i].value + ' backs' })
          break;
       
         default:
          res.push({property:propertyName[state['options_description'].options[i].name],value:state['options_description'].options[i].value})
          break;
       }
       
 
     }
  }
  //console.log('REVIEW STATE',state)
  return res;
  
  }
  
 

const mapDispatchToProps = (dispatch, ownProps) => ({

  onOpenReview: ( () => {
   // console.log('review event')
    ReactGA.event({
    category: 'Review',
    action:'Review'})}
    )
  /////onClick: ( () => dispatch(state_update({attr:'review',value:false})))
 // onClick: () =>state_update({attr:ownProps.attr,value:ownProps.value})
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AiReview)


// WEBPACK FOOTER //
// ./src/layout/AiReviewWrap.js